import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { api } from '../../utils/api';
import toast from 'react-hot-toast';

const OverlayLanding = () => {
  const { user, logout } = useAuth();
  const [overlays, setOverlays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOverlays();
  }, []);

  const fetchOverlays = async () => {
    try {
      const response = await api.get('/overlays');
      setOverlays(response.data.overlays);
    } catch (error) {
      console.error('Failed to fetch overlays:', error);
      toast.error('Failed to load overlays');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (overlayId, overlayTitle) => {
    if (!window.confirm(`Are you sure you want to delete "${overlayTitle}"?`)) {
      return;
    }

    try {
      await api.delete(`/overlays/${overlayId}`);
      toast.success('Overlay deleted successfully');
      fetchOverlays();
    } catch (error) {
      console.error('Failed to delete overlay:', error);
      toast.error('Failed to delete overlay');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400 text-sm">Loading overlays...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white font-sans p-12">
    

      {/* Main Content Area */}
      <div className="p-6 bg-[#1c1c1c]">
        {/* Overlay Cards Grid */}
        <div className="grid grid-cols-2 gap-4">
          {overlays.map((overlay) => (
            <div key={overlay.id} className="bg-[#323232] border-2 border-white p-4 flex items-center justify-between">
              <div className="flex-1">
                <div className="text-lg font-bold tracking-wider uppercase mb-1">
                  {overlay.title || 'TITLE'}
                </div>
                <div className="text-sm tracking-wider uppercase">
                  {overlay.subtitle || 'SUBTITLE'}
                </div>
              </div>
              <div className="flex items-center gap-4">
                <Link
                  to={`/overlays/${overlay.id}/edit`}
                  className="text-sm font-medium tracking-wider uppercase hover:text-red-400 transition-colors"
                >
                  EDIT
                </Link>
                <Link
                  to={`/overlays/${overlay.id}/view`}
                  target="_blank"
                  className="text-sm font-medium tracking-wider uppercase hover:text-red-400 transition-colors"
                >
                  VIEW
                </Link>
                <Link
                  to={`/overlays/${overlay.id}/control`}
                  className="text-sm font-medium tracking-wider uppercase hover:text-red-400 transition-colors"
                >
                  CONTROL
                </Link>
                <button
                  onClick={() => handleDelete(overlay.id, overlay.title)}
                  className="text-sm font-medium tracking-wider uppercase hover:text-red-400 transition-colors"
                >
                  DELETE
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t-8 border-black bg-[#1c1c1c] p-4 flex items-center justify-between">
        <div className="flex items-center gap-12">
          <div className="flex items-center gap-4">
            <div className="text-lg font-bold tracking-wider uppercase">PopUps</div>
            <Link
              to="/popups"
              className="text-sm font-medium tracking-wider uppercase px-4 py-2 border border-white hover:bg-red-600 hover:text-white transition-colors"
            >
              Edit
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-lg font-bold tracking-wider uppercase">Member Scroll</div>
            <Link
              to="/member-scroll"
              className="text-sm font-medium tracking-wider uppercase px-4 py-2 border border-white hover:bg-red-600 hover:text-white transition-colors"
            >
              Edit
            </Link>
          </div>
        </div>
        <Link
          to="/overlays/new"
          className="w-10 h-10 border-2 text-2xl border-white flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors"
        >
          +
        </Link>
      </div>
    </div>
  );
};

export default OverlayLanding;